import MyCartButton from "../../../common/header/MyCartButton.tsx";
import { CompareCart } from "common/api/decimal/methods/compareAndPurchase.ts";

export default function CompareAndPurchaseCartButton({
  cart,
}: {
  cart: CompareCart | undefined;
}) {
  if (!cart) {
    return null;
  }

  const count = cart.bookItems.length ?? 0;
  const price = cart.totalPrice ?? 0;

  return <MyCartButton count={count} price={price} to="/my-courses/my-cart" />;
}
